/**
 * Centralized client env access. Anything coming from import.meta.env
 * goes through here so the rest of the app stays unaware of Vite specifics.
 */

interface ImportMetaEnvShape {
  VITE_API_URL?: string;
  VITE_RQ_DEVTOOLS?: string;
  MODE: "development" | "production" | "test";
  DEV: boolean;
  PROD: boolean;
}

const ime = import.meta.env as unknown as ImportMetaEnvShape;

export const env = {
  apiUrl: ime.VITE_API_URL?.replace(/\/$/, "") || "",   // empty -> use vite proxy /api
  rqDevtools: ime.VITE_RQ_DEVTOOLS === "true",
  isDev: ime.DEV,
  isProd: ime.PROD,
  mode: ime.MODE,
} as const;

/** Resolve absolute API URL when env.apiUrl is set, otherwise return relative
 *  (which the Vite dev proxy or Capacitor server config will route).        */
export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return env.apiUrl ? `${env.apiUrl}${p}` : p;
}
